import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import CloseButton from "react-bootstrap/CloseButton";
import "./style.scss";
import CommonButton from "../../commonButton";

const RenameTaskModal = ({ show, onHide, documentName, onUpdate }) => {
  const [newDocumentName, setNewDocumentName] = useState(() => documentName ?? "");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  // Parent often sets documentName after async load; initial useState only runs once.
  // Reset when the modal opens so the field shows the current name.
  useEffect(() => {
    if (show) {
      setNewDocumentName(documentName ?? "");
      setError("");
    }
  }, [show, documentName]);

  const handleUpdate = async () => {
    if (!newDocumentName.trim()) {
      setError("This field is required");
      return;
    }

    setError("");
    setIsLoading(true);
    try {
      await onUpdate(newDocumentName.trim());
      onHide();
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e) => {
    setNewDocumentName(e.target.value);
    if (error) {
      setError("");
    }
  };

  return (
    <Modal show={show} centered onHide={onHide} className="common-popup">
      <Modal.Header className="rename-modal-header">
        <div className="form-modal">
          <Modal.Title>Rename Document</Modal.Title>
        </div>
        <CloseButton onClick={onHide} className="close-cta-wrapper" />
      </Modal.Header>
      <Modal.Body>
        <div className="rename-document-form">
          <div className="form-group modal-input-wrapper">
            <label htmlFor="documentName">Document Name</label>
            <div className="d-flex">
              <input
                type="text"
                id="documentName"
                value={newDocumentName}
                onChange={handleInputChange}
                className={`form-control ${error ? "is-invalid" : ""}`}
                placeholder="Enter document name"
              />
              {error && <div className="invalid-feedback d-block">{error}</div>}
            </div>
          </div>
          <div className="update-button-wrapper">
            <CommonButton
              variant="primary"
              onClick={handleUpdate}
              btnText={isLoading ? "UPDATING..." : "UPDATE"}
              disabled={isLoading}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RenameTaskModal;
